import { State } from "../../../vendor_core/core/src/states/State";
import BURFeatureModel from "../models/BURFeatureModel";
import BURReelsModel from "../models/BURReelsModel";

/**
 * Tweaks the spin data to match the pre-feature state because
 * the init response has the post-feature updated data
 */
export default class BURRecoverFeatureState extends State {
    public async enter() {
        super.enter();

        // Revert the progress of the energy meters because the coins will charge them during the recover
        BURFeatureModel.energy_coins
            .filter((coin) => coin.affectsMeter || coin.color === "Yellow")
            .forEach((coin) => {
                BURReelsModel.energy_meters.onRecover(coin.color, -1);
            });
        BURFeatureModel.mystery_energy_coins
            .filter((coin) => coin.affectsMeter || coin.color === "Yellow")
            .forEach((coin) => {
                BURReelsModel.energy_meters.onRecover(coin.color, -1);
            });
        BURFeatureModel.replay_energy_coins
            .filter((coin) => coin.affectsMeter || coin.color === "Yellow")
            .forEach((coin) => {
                BURReelsModel.energy_meters.onRecover(coin.color, -1);
            });

        this.exit();
    }
}
